export enum MapHeight {
  Large = '31.25rem',
  Small = '13.75rem',
}
